import { exhaustiveCheck } from '../../../utils/exhaustive-check';

type Variant = 'WORKFLOWS';

type SideNavSectionHeaderProps = {
  variant: Variant;
};

export const SideNavSectionHeader = ({ variant }: SideNavSectionHeaderProps) => {
  const title = getTitle(variant);

  return (
    <div className="pl-2.5">
      <p className="text-xs font-normal leading-5 tracking-tight text-seapoint-gray">{title}</p>
    </div>
  );
};

const getTitle = (variant: Variant) => {
  switch (variant) {
    case 'WORKFLOWS':
      return 'Workflows';
    default:
      return exhaustiveCheck(variant);
  }
};
